import styled from "@emotion/styled";
import { Box } from "@mui/material";

const CustomBox = styled(Box)({
  paddingBottom: "30px",
  color: "white",
});

export default CustomBox;
